'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'arrow-up-from-bracket';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e09a';
var svgPathData = 'M246.6 9.4L224-13.3 201.4 9.4 73.4 137.4 50.7 160 96 205.3c6.6-6.6 38.6-38.6 96-96l0 242.7 64 0 0-242.7c57.4 57.4 89.4 89.4 96 96l45.3-45.3-22.6-22.6-128-128zM64 352l0-32-64 0 0 192 448 0 0-192-64 0 0 128-320 0 0-96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowUpFromBracket = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;